import { makeStyles } from '@material-ui/core/styles'

export const containerStyles = makeStyles((theme) => ({
    hero: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
    },

    textWrapper: {
        textAlign: 'center'
    },

    headline: {
        fontSize: '8rem',
        color: '#FFFFFF',
        fontWeight: 100,
        lineHeight: 1,
        [theme.breakpoints.down('md')]: {
            fontSize: '4rem',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '3rem',
        },
    },

    headlineFirstLetter: {
        '&::firstLetter': {
            fontSize: '20rem',
        }
    },

    subHeadline: {
        fontSize: '4rem',
        color: '#FFFFFF',
        [theme.breakpoints.down('md')]: {
            fontSize: '2rem',
        },
    },
    parallax: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1,
        opacity: 0.9,
    },
    overflow: {
        height: '200vh'
    },
    mainContainer: {
        fontFamily: 'Encode, sans-serif',
        textAlign: 'center'
    },
    pageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        alignItems: 'center',
        padding: '40px 100px 50px 100px',
        backgroundColor: '#161616'
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: 20,
        marginTop: 20,
        marginRight: 5,
        width: '100%'
    },
    authContainer: {
        display: 'flex',
        minHeight: '90vh',
        height: '100%',
        backgroundColor: '#161616',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15
    },
    auth1Container: {
        display: 'flex',
        height: '100%',
        width: '100%',
        backgroundColor: '#161616',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: 50,
        alignItems: 'center',
        padding: 15
    },
    outerCardContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column'
    },
    innerCardContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
            flexDirection: 'column',
        },
    },
    lastHomeSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 60,
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            flexDirection: 'column',

        },
    },
    videoPlayerContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: 'auto',
        width: '95%',
        height: 'auto',
        aspectRatio: '16/9',
        maxWidth: 1200,
        [theme.breakpoints.up('xl')]: {
            width: '85%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '90%',
        },
        [theme.breakpoints.between('md', 'lg')]: {
            width: '95%',
        },
        [theme.breakpoints.down('md')]: {
            width: '95%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '98%',
        },
    },
    timerContainer: {
        backgroundColor: '#008000',
        padding: 10,
        margin: '10px 10px',
        borderRadius: 5
    },

    timerContainerLost: {
        backgroundColor: 'red',
        color: 'white',
        fontSize: 20,
        padding: 10,
        margin: '10px 10px',
        borderRadius: 5
    },
    outerLostDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    lostTimerDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '15px 0',
        width: '100%',
    },
    lostBtnDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    symbols: {
        margin: 8,
        width: 70,
        height: 70
    },
    innerAuthContainer: {
        minWidth: 500,
        minHeight: 400,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        alignItems: 'center',
        borderColor: '#33949E',
        borderStyle: 'solid',
        borderRadius: 8,
        borderWidth: '1',
        padding: 20,
        filter: 'drop-shadow',
        boxShadow: '0 5px 10px #33949E'
    },
    loginInputs: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '80%',
        margin: 'auto'
    },
    navWrap: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'

    },
    navBtnWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    forgotPass: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    mainLinks: {
        borderColor: '#33949E',
        borderStyle: 'solid',
        borderRadius: 8,
        borderWidth: '1',
        padding: 20,
        minWidth: 240,
        margin: 20,
        filter: 'drop-shadow',
        boxShadow: '0 5px 10px #33949E',
        '&:hover': {
            backgroundColor: 'white',
            cursor: 'pointer',
            color: '#33949E',
        }
    },
    outLink: {
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'center',
        marginTop: 100,
        justifyContent: 'center',
        alignContent: 'center',

    },
    link: {
        color: '#33949E',
        textAlign: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        paddingLeft: 30,
        '&:hover': {
            color: '#33949E',
        }
    },
    selectGrid: {
        width: '100%',
        padding: '20px 0',
        backgroundColor: '#33949E',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        position: 'sticky',
        bottom: 0
    },

}))
